import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	const [input3, onChangeInput3] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 2200,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 89,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 32,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ryu25utm_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8ibxfzx7_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4qi5t8zb_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 4,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3fvnrykx_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Requests"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 30,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ls1d1t6y_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 12,
									paddingRight: 90,
									marginBottom: 30,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jo57bkp1_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Chats"}
									value={input1}
									onChange={(event)=>onChangeInput1(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 16,
										width: 42,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6569twoo_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Curriculum"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/iid0pmzm_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Lessons"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 32,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ywhzmju4_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingTop: 8,
									paddingBottom: 8,
									paddingLeft: 8,
									paddingRight: 11,
									marginBottom: 32,
									marginLeft: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/a6n3s5gl_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Mentors"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/e91m4d09_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Progress"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/w792zhth_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dkka1r2w_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Bookmarks"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/o3q86oy3_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Downloads"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ivdzrzst_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Notifications"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xvocqa41_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input2}
								onChange={(event)=>onChangeInput2(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hdyrm5kj_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/c3p21fmo_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hqwtrqa4_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginBottom: 32,
							marginLeft: 267,
						}} >
						{"Giia AI Agent"}
					</span>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 19,
								marginRight: 23,
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 20,
									gap: 8,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/76oa8fys_expires_30_days.png"} 
									style={{
										width: 32,
										height: 32,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 20,
										fontWeight: "bold",
									}} >
									{"Giia"}
								</span>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 27,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FAFAFA",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 12,
									paddingBottom: 12,
									paddingLeft: 16,
									paddingRight: 225,
									marginBottom: 21,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9p2st34e_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Search chat..."}
									value={input3}
									onChange={(event)=>onChangeInput3(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										width: 88,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/eyw0dub7_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 211,
									}} >
									{"Curriculum"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/k7gr2e95_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/t780xc0c_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 231,
									}} >
									{"Lessons"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/wyqw99s6_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/qlyzjm78_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 227,
									}} >
									{"Progress"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cnno8bz0_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dyl7bdb0_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 214,
									}} >
									{"Resources"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/v7dt1dyq_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ow3tsf4z_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 206,
									}} >
									{"Community"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dldslm2x_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2jxc697w_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 189,
									}} >
									{"Chats History"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/uowme977_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/525ax5fu_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 125,
									}} >
									{"Bookmarks Resources"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/1hr5idpu_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ua20uy4h_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 125,
									}} >
									{"Downloads Resources"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/sni2purf_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 38,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
									borderRadius: 12,
									paddingTop: 22,
									paddingBottom: 22,
									paddingLeft: 23,
									paddingRight: 115,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/furqklgo_expires_30_days.png"} 
									style={{
										width: 48,
										height: 48,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 8,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											gap: 11,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
											}} >
											{"Guy Hawkins"}
										</span>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 3,
												paddingLeft: 6,
												paddingRight: 6,
											}}>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"mentor"}
											</span>
										</div>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 6,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cry9k52l_expires_30_days.png"} 
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"yourguy123@email.com"}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 797,
								background: "#E6E6E6",
								marginRight: 18,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 22,
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 18,
									marginLeft: 277,
									gap: 8,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/m89s5005_expires_30_days.png"} 
									style={{
										width: 32,
										height: 32,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Giia AI Agent"}
								</span>
							</div>
							<div 
								style={{
									width: 691,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 28,
								}}>
							</div>
							<div 
								style={{
									alignSelf: "stretch",
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-end",
									marginBottom: 12,
								}}>
								<span 
									style={{
										color: "#1074BC",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 2,
									}} >
									{"Your question:"}
								</span>
							</div>
							<div 
								style={{
									alignSelf: "stretch",
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-end",
									marginBottom: 32,
								}}>
								<button 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#E7F1F8",
										borderRadius: 12,
										border: "none",
										paddingTop: 12,
										paddingBottom: 12,
										paddingLeft: 14,
										paddingRight: 14,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
										}} >
										{"Giia, how do I write a business plan?"}
									</span>
								</button>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 12,
									marginLeft: 8,
									gap: 8,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zdtsf54p_expires_30_days.png"} 
									style={{
										width: 32,
										height: 32,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
									}} >
									{"Giia response:"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									marginLeft: 8,
									position: "relative",
								}}>
								<div 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FEF0E9",
										borderRadius: 12,
										paddingTop: 12,
										paddingBottom: 67,
										gap: 20,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											marginLeft: 14,
											width: 308,
										}} >
										{"Great question! A solid business plan is crucial. Let's break it down."}
									</span>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											marginLeft: 14,
											marginRight: 14,
											width: 335,
										}} >
										{"Here's a structured approach:\n\n1. Executive Summary: A brief overview of your business.\n\n2. Company Description: Your mission, vision, and core values.\n\n3. Market Analysis: Understanding your target audience and competitors.\n\n4. Products/Services: Detailed description of what you offer.\n\n5. Marketing and Sales Strategy: How you'll reach and acquire customers.\n\n6. Financial Projections: Revenue, expenses, and funding needs.\n\n7. Appendix: Supporting documents."}
									</span>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											marginLeft: 14,
											width: 308,
										}} >
										{"Would you like me to elaborate on any of these sections? or would you like a template?"}
									</span>
								</div>
								<div 
									style={{
										position: "absolute",
										bottom: 0,
										left: -25,
										width: 734,
										display: "flex",
										alignItems: "center",
										background: "#FFFFFF",
										borderTopLeftRadius: 16,
										borderTopRightRadius: 16,
										borderBottomRightRadius: 16,
										paddingTop: 20,
										paddingBottom: 32,
										paddingLeft: 32,
										paddingRight: 32,
										boxShadow: "0px -2px 4px #00000000",
									}}>
									<span 
										style={{
											color: "#979797",
											fontSize: 16,
											flex: 1,
										}} >
										{"Write your message..."}
									</span>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											gap: 10,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7p3ef6bb_expires_30_days.png"} 
											style={{
												width: 27,
												height: 27,
												objectFit: "fill",
											}}
										/>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/d9sgetn8_expires_30_days.png"} 
											style={{
												width: 27,
												height: 27,
												objectFit: "fill",
											}}
										/>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xvw7bili_expires_30_days.png"} 
											style={{
												width: 27,
												height: 27,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}